import {
  LIST_ROLE,
  CREATE_ROLE,
  UPDATE_ROLE,
  DELETE_ROLE,
  LIST_ROLE_PERM,
  CREATE_ROLE_PERM,
  UPDATE_ROLE_PERM,
  DELETE_ROLE_PERM,
} from '../constant'
import axios from 'axios'
import * as REPO from '../helper/main'

const localKey = 'token'

export const getListRole = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(LIST_ROLE, config_token)
}

export const postRole = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(CREATE_ROLE, data, config_token)
}

export const updateRole = (data, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(UPDATE_ROLE + id, data, config_token)
}

export const deleteRole = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.delete(DELETE_ROLE + id, config_token)
}

// Role Permission
export const getListRolePerm = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(LIST_ROLE_PERM, config_token)
}

export const postRolePerm = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(CREATE_ROLE_PERM, data, config_token)
}

export const updateRolePerm = (data, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(UPDATE_ROLE_PERM + id, data, config_token)
}

export const deleteRolePerm = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.delete(DELETE_ROLE_PERM + id, config_token)
}
